module.exports = __webpack_public_path__ + "static/img/processDispensing.71078e82.png";